import { useContext } from 'react';

import { Trans } from '@lingui/react/macro';
import { TableCell, TableRow } from '@repo/videa-components/src/ui/table';
import classNames from 'classnames';

import { getBoneLossLabel, getMobilityLabel, getPlaqueLabel } from './helpers';
import { PerioChartModeContext, type PerioChartTooth } from './types';

interface Props {
  teeth: PerioChartTooth[];
}

export const PlaqueMobilityBoneLossRow = ({ teeth }: Props) => {
  const mode = useContext(PerioChartModeContext);

  return (
    <TableRow className="vai-border-none">
      <TableCell
        className={classNames(
          'vai-font-inter vai-text-[12px] !vai-py-[2px] !vai-px-2 vai-border vai-border-zinc-700',
          {
            'vai-text-zinc-300': mode === 'dark',
            'vai-text-zinc-950': mode === 'light',
          },
        )}
      >
        <Trans>Plaque/Mobility/Bone Loss</Trans>
      </TableCell>

      {teeth.map((tooth) => {
        const plaqueLabel = getPlaqueLabel(tooth.plaque);
        const mobilityLabel = getMobilityLabel(tooth.mobility);
        const boneLossLabel = getBoneLossLabel(tooth.boneLoss);

        return (
          <TableCell
            className={classNames(
              'vai-font-inter vai-text-[12px] !vai-py-[2px] !vai-px-2 vai-border vai-border-zinc-700',
              {
                'vai-text-zinc-50': mode === 'dark',
                'vai-text-zinc-950': mode === 'light',
              },
            )}
            key={tooth.toothNumber}
          >
            <div className="vai-w-full vai-flex vai-justify-between vai-items-center vai-gap-1">
              <p>{plaqueLabel}</p>
              <p>{mobilityLabel}</p>
              <p>{boneLossLabel}</p>
            </div>
          </TableCell>
        );
      })}
    </TableRow>
  );
};
